<template>
  <div class="query-page">
    <el-dialog title="历史记录" width="80%" :visible.sync="dialogTableVisible">
        <div class="historylist">
            <div class="title">当前数据</div>
            <el-table
                :data="localdata"
                border
                stripe
                style="width: 100%"
                size="small"
                header-cell-class-name="table-header-cell"
                >
                <el-table-column prop="create_time" label="时间" width="150" />
                <el-table-column prop="regionname" label="组名" />
                <el-table-column prop="address_desc" label="地址" />
                <el-table-column prop="name" label="姓名" />
                <el-table-column prop="identity" label="身份" />
                <el-table-column prop="phone" label="联系方式" />
                <el-table-column prop="gas_supplier" label="燃气厂家" />
                <el-table-column label="安心管">
                    <template slot-scope="scope">
                    {{ scope.row.pipe_safe == '0' ? '正常' : '异常' }}
                    </template>
                </el-table-column>
                <el-table-column label="照片" width="80">
                    <template slot-scope="scope">
                    <el-image
                        v-if="scope.row.picpathlist && scope.row.picpathlist.length"
                        style="width: 50px; height: 50px;"
                        fit="cover"
                        :src="scope.row.picpathlist[0]"
                        :preview-src-list="scope.row.picpathlist"
                    />
                    <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" show-overflow-tooltip />
                <el-table-column prop="create_man" label="操作员" />
                <el-table-column label="状态">
                    <template slot-scope="scope">
                    <el-tag
                        :type="scope.row.is_abnormal == '0' ? 'success' : 'danger'"
                        size="small"
                        effect="plain"
                    >{{ scope.row.is_abnormal == '0' ? '正常' : '异常' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="update_time" label="整改时间"  width="150"  />
            </el-table>
        </div>
        <div class="historylist" style="margin-top: 20px;">
            <div class="title">复核历史记录</div>
            <el-table
                :data="allRecords"
                border
                stripe
                style="width: 100%"
                size="small"
                header-cell-class-name="table-header-cell"
                >
                <el-table-column prop="create_time" label="时间" width="150" />
                <el-table-column prop="regionname" label="组名" />
                <el-table-column prop="address_desc" label="地址" />
                <el-table-column prop="name" label="姓名" />
                <el-table-column prop="identity" label="身份" />
                <el-table-column prop="phone" label="联系方式" />
                <el-table-column prop="gas_supplier" label="燃气厂家" />
                <el-table-column label="安心管">
                    <template slot-scope="scope">
                    {{ scope.row.pipe_safe == '0' ? '正常' : '异常' }}
                    </template>
                </el-table-column>
                <el-table-column label="照片" width="80">
                    <template slot-scope="scope">
                    <el-image
                        v-if="scope.row.picpathlist && scope.row.picpathlist.length"
                        style="width: 50px; height: 50px;"
                        fit="cover"
                        :src="scope.row.picpathlist[0]"
                        :preview-src-list="scope.row.picpathlist"
                    />
                    <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" show-overflow-tooltip />
                <el-table-column prop="create_man" label="操作员" />
                <el-table-column label="状态">
                    <template slot-scope="scope">
                    <el-tag
                        :type="scope.row.is_abnormal == '0' ? 'success' : 'danger'"
                        size="small"
                        effect="plain"
                    >{{ scope.row.is_abnormal == '0' ? '正常' : '异常' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="update_time" label="整改时间"  width="150"  />
            </el-table>

            <!-- Pagination -->
            <div class="paginationbox">
                <el-pagination
                    @current-change="goToPage"
                    :current-page.sync="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalRecords"
                />
            </div>
      </div>
    </el-dialog>
</div>
</template>

<script>
import { getUserpageHistoryList, getGasListFn, getCunZuYiChang } from '@/api/gasdashboard'
export default {
  name: 'QueryPage',
  data() {
    return {
      groupOptions: [],
      companyOptions: [],
      currentPage: 1,
      pageSize: 10,
      allRecords: [],
      totalRecords: 0,
      dialogTableVisible: false,
      uuid: '',
      localdata: []
    }
  },
  mounted() { 
    this.getGasList();
    this.getAllGroupInfo();
  },
  computed: {

  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= Math.ceil(this.totalRecords / this.pageSize)) {
        this.currentPage = page
      }
      this.getUserHistoryList()
    },
    getUserHistoryList(){
        this.totalRecords = [];
        this.localdata = [];
        getUserpageHistoryList({
            'x-access-token': this.GLOBAL.token(),
            userid: this.GLOBAL.adminId(),
            page: this.currentPage,
            pagesize: this.pageSize,
            ncrq_gas_user_uuid: this.uuid
        }).then((res) => {
            if (res.result == '200') {
                this.totalRecords = res.detail.historylist.totalRow;
                this.allRecords = res.detail.historylist.list;
                this.localdata.push(res.detail.ncrqbean);
            } else {
                this.$message.error(res.description);
            }
        })
    },
    //获取小组的数据
    getAllGroupInfo() { 
         getCunZuYiChang({
            'x-access-token': this.GLOBAL.token(),
            userid: this.GLOBAL.adminId()
        }).then((res) => {
            if (res.result == '200') {
                let data = res.detail;
                this.groupOptions = data.map(item => { 
                  return {
                    regioncode: item.regioncode,
                    regionname: item.regionname
                  }
                });
            } else {
                this.$message.error(res.description);
            }
        })
    },
    //获取燃气列表
    getGasList() { 
        getGasListFn({
            'x-access-token': this.GLOBAL.token(),
            userid: this.GLOBAL.adminId(),
        }).then((res) => {
            if (res.result == '200') {
                this.companyOptions = res.detail;
            } else {
                this.$message.error(res.description);
            }
        })
    },
    
  }
}
</script>

<style lang="scss" scoped>
@import "./variables.scss";
// ========== Layout ==========
.query-page {
  background-color: $page-bg;
  padding: 12px;
  min-height: calc(100vh - 100px);
  box-sizing: border-box;
}
.historylist{
    padding: 0 20px;
}
.title {
    font-size: $font-size-xl;
    font-weight: 600;
    color: $text-primary;
    line-height: 2em;
 }

.paginationbox {
    margin-top: $spacing-lg;
    text-align: center;
}

// ========== Table Header Style ==========
:deep(.table-header-cell) {
  font-weight: 600;
  color: $text-secondary;
  background: $table-header-bg;
}
</style>
